export default "__VITE_PUBLIC_ASSET__1601c4e1__"